var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rankorder-input"},[_c('draggable',{model:{value:(_vm.list),callback:function ($$v) {_vm.list=$$v},expression:"list"}},_vm._l((_vm.list),function(option,i){return _c('div',{key:i,staticClass:"item"},[_c('span',{staticClass:"pill"},[_vm._v(_vm._s(i + 1))]),_vm._v(_vm._s(option)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }